import { render } from "./HelpCompetitionDialog.vue?vue&type=template&id=cf791760"
import script from "./HelpCompetitionDialog.vue?vue&type=script&lang=js"
export * from "./HelpCompetitionDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__